import {
    useQuery,
    UseQueryOptions,
    QueryKey,
    UseQueryResult,
} from '@tanstack/react-query';
import {useEffect} from "react";

type FetchFunction<TData> = () => Promise<TData>;

export function useGenericQuery<TData>(
    key: QueryKey,
    fetchFunction: FetchFunction<TData>,
    onSuccess: (data: TData) => void,
    options?: Omit<UseQueryOptions<TData, unknown, TData, QueryKey>, 'queryKey' | 'queryFn'>
): UseQueryResult<TData, unknown> {

    const queryOptions: UseQueryOptions<TData, unknown, TData, QueryKey> = {
        queryKey: key,
        retry: false,
        refetchOnWindowFocus: false,
        ...options,
        queryFn: () => fetchFunction()
    };

    const result = useQuery<TData, unknown, TData, QueryKey>(queryOptions);

    useEffect(() => {
        if (result.status === 'success' && onSuccess) {
            onSuccess(result.data);
        }
    }, [result.status, result.data, onSuccess]);

    return result;
}
